import { render, staticRenderFns } from "./ModifierModal.vue?vue&type=template&id=176ddcff"
import script from "./ModifierModal.vue?vue&type=script&lang=js"
export * from "./ModifierModal.vue?vue&type=script&lang=js"
import style0 from "./ModifierModal.vue?vue&type=style&index=0&id=176ddcff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports